import { ComposeViewState } from 'owa-mail-compose-store';
import addInfoBarMessage from '../actions/addInfoBarMessage';

const CLP_LABEL_INFOBAR_MESSAGE_ID = 'CLPLabel';

export default function addCLPLabelInfoBar(composeViewState: ComposeViewState) {
    if (
        composeViewState &&
        composeViewState.clpViewState &&
        composeViewState.clpViewState.selectedCLPLabel &&
        !composeViewState.clpViewState.selectedCLPLabel.isDefault
    ) {
        // the item should show info bar of CLP Label
        addInfoBarMessage(composeViewState, CLP_LABEL_INFOBAR_MESSAGE_ID);
    }
}
